import axios from "axios";

export default async function getDownload() {
  return await axios({
    method: "GET",
    url: `https://hassei-ki-backend.onrender.com/api/download`,
    responseType: "arraybuffer",
  });
}
